import $ from 'jquery'
import ExcelModal from '@/views/parametres/import-excel-modal'

export default {
	name: 'assurances',
	components: {
		ExcelModal
	},
	props: [],
	data() {
		return {
			user_role: '',           //  Role d'un utilisateur

			fields: ['nom', { key: 'telephone', label: 'Téléphone' }, 'email', 'actions'],

			filter: "",
			tableIsBusy: true,
			perPage: 20,
			currentPage: 1,

			is_empty: false,
			is_loading: true,

			// Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
			country_code: '',

			prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci', 'bf'],

			compagnie: {
				compagnie_id: 0,
				nom: '',
				code_tel: '',
				telephone: '',
				email: '',
				adresse: '',
				is_edit: 0
			},
			save_loading: false,
			btn_disable: false,

			compagnie_to_be_deleted: [],
            del_loading: false,
            is_confirm: false,

			// Groupe assurance
			groupe_assur: '',
			groupe_assur_id: 0,
			grp_loading: true,
			grp_is_empty: false,
			groupe_to_be_deleted: [],

			grp_fields: ['groupes', {key: 'default', label: 'Base'}, 'actif', 'actions'],
			grp_per_page: 5,
			is_list_group: true,

			g_default: '',
			g_actif: '',
			type_import: '',
			designation: '',
			emit_action: '',
			modal_toggler: true,

			assur_loading_percentage: 0,
            can_view_percentage: false,
            assur_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
		}
	},

	watch: {
		g_default() {
			this.changeDefaultBase('default', this.g_default)
		},

		g_actif() {
			this.changeDefaultBase('actif', this.g_actif)
		}
	},

	computed: {
		compagnie_assurances() {
            return this.$store.getters["compagnie_assurances"];
        },

		rows() {
            return this.compagnie_assurances.length;
        },
	},

	mounted() {
		this.fetchListeAssurances()
	},

	beforeDestroy() {
        if (this.assur_refresh_timeout_id) {
            clearTimeout(this.assur_refresh_timeout_id)
            this.assur_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

	methods: {
		countdownLoad() {
            const TOTAL_SECONDS = 4 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.assur_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.assur_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.assur_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeAssurance() {
            this.is_loading = true
            this.can_view_percentage = true
            if (this.assur_refresh_timeout_id) {
                clearTimeout(this.assur_refresh_timeout_id)
                this.assur_refresh_timeout_id = null
            }

            if (this.compagnie_assurances.length > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.fetchListeAssurances()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.fetchListeAssurances()
            this.assur_refresh_timeout_id = setTimeout(() => {
                this.refreshListeAssurance()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeAssurance()
        },

		fetchListeAssurances() {
			this.is_loading = true

			this.$store.dispatch("getAssurance").then(() => {
				if(this.compagnie_assurances.length > 0) {
					this.is_empty = false
				} else {
					this.is_empty = true
				}

				if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.is_loading = false
                    }
                } else {
                    this.is_loading = false
                }
			});
		},

		clearError() {
			for (let i = 1; i <= 3; i++) {
				$('.err-msg-'+i).fadeOut(500)
			}
		},

		changeDefaultBase(type_config, groupe_id) {
			let data = {
				type_config: type_config,
				groupe_id: groupe_id
			}

			this.$store.dispatch('configBaseActifAssurance', data)
		},

		countryChanged(country) {
            this.compagnie.code_tel = '+'+country.dialCode
        },

		async submit() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch("addAssurance", this.compagnie).then((response) => {
                if (response > 0) {
                    this.fetchListeAssurances();

					
					if (this.compagnie.is_edit == 0) {
						this.successMsg('Compagnie d\'assurance ajouté avec succès')
					} else {
						this.successMsg('Compagnie d\'assurance modifié avec succès')
					}
					$('.modal').modal('hide')
                    
                    this.compagnie = {
						compagnie_id: 0,
						nom: '',
						code_tel: '',
						telephone: '',
						email: '',
						adresse: '',
						is_edit: 0
					}
					
					
                } else {
					if (response == -1) {
						$('.err-msg-1').fadeIn(500)
					} else if (response == -2) {
						$('.err-msg-2').fadeIn(500)
					} else if (response == -3) {
						$('.err-msg-3').fadeIn(500)
					}
                }
				this.save_loading = false
                this.btn_disable = false
            })
		},

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		doErrorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                theme: 'toasted-primary',
                type: 'error'

            })
        },

		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		remove(data) {
			this.compagnie_to_be_deleted = {
                id: data.id,
                compagnie: data.compagnie_assurance,
            }
		},

		edit (data) {
			let phone_number = ''
			if (data.telephone != '' && data.telephone != null) {
				phone_number = data.telephone.split("+228").pop()
			} 
			
			this.compagnie = {
				compagnie_id: data.id,
				nom: data.compagnie_assurance,
				code_tel: '',
				telephone: phone_number,
				email: data.email,
				adresse: data.adresse,
				is_edit: 1
			}
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteCompagnie', this.compagnie_to_be_deleted).then((response) => {
                    console.log("DEL repsonse : ", response)
                    if (response > 0) {
                        this.successMsg('Compagnie d\'assurance supprimé avec succès')
                    }

					this.fetchListeAssurances();
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    
                })
            }
        },

		backToList() {
			$('.new-group').fadeOut(500)
			setTimeout(() => {
				$('.list-group').fadeIn()
			}, 500);
			this.is_list_group = true
		},

		importExcelFile(type_import, designation) {
            this.type_import = type_import
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListAssurance'

            setTimeout(() => {
                $('.excel-modal-'+type_import).modal('show')
            }, 200);
        },
	}
}


